export const items = [
  {
    id: "barcode",
    label: "Barcode",
  },
];

export const keys = [
  {
    value: "label",
  },
  {
    value: "remove",
    CustomComponent: () => {},
  },
];
